module.exports = __webpack_public_path__ + "img/not-authorized.f9b6d97a.svg";